import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/new-enrollments")({
	component: NewEnrollmentsLayout,
});

function NewEnrollmentsLayout() {
	return <Outlet />;
}
